import { __decorate } from "tslib";
import { Pipe } from 'angular-ts-decorators';
var isNumber = function (value) {
    return typeof value === 'number' && !isNaN(value);
};
var BytesPipe = (function () {
    function BytesPipe() {
    }
    BytesPipe.prototype.transform = function (bytes, precision, unit) {
        var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
        var size = 0;
        var result = '';
        var unitIndex = units.indexOf(unit);
        var stepSize = Math.pow(1024, unitIndex === -1 ? 1 : unitIndex);
        if (!isNumber(bytes) || !isFinite(bytes) || bytes <= 0) {
            return result;
        }
        if (!isNumber(precision)) {
            precision = 1;
        }
        if (unitIndex === -1) {
            while (bytes >= stepSize) {
                bytes /= stepSize;
                size++;
            }
            if (size === 0) {
                bytes /= stepSize;
            }
        }
        else {
            bytes /= stepSize;
        }
        result = bytes.toFixed(+precision) + ' ' + units[unitIndex === -1 ? size : unitIndex];
        return result;
    };
    BytesPipe = __decorate([
        Pipe({
            name: 'bytes',
        })
    ], BytesPipe);
    return BytesPipe;
}());
export { BytesPipe };
